/**
 * Shopify Dynamic Checkout Button Initializer
 * Ensures Shop Pay, PayPal, and other dynamic payment buttons load properly
 */

(function() {
  'use strict';
  
  console.log('💳 Payment Button Initializer Loading...');
  
  /**
   * Initialize Shopify Payment Buttons
   */
  function initializePaymentButtons() {
    console.log('💳 Initializing Shopify payment buttons...');
    
    // Find all payment button wrappers
    const paymentWrappers = document.querySelectorAll('.shop-pay-button-wrapper, .shopify-payment-button');
    
    if (paymentWrappers.length === 0) {
      console.log('💳 No payment button wrappers found');
      return;
    }
    
    console.log(`💳 Found ${paymentWrappers.length} payment button wrapper(s)`);
    
    // Check if Shopify.PaymentButton exists
    if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
      console.log('💳 Shopify.PaymentButton found, initializing...');
      try {
        Shopify.PaymentButton.init();
        console.log('✅ Payment buttons initialized successfully');
      } catch (error) {
        console.error('❌ Error initializing payment buttons:', error);
      }
    } else {
      console.log('💳 Shopify.PaymentButton not available yet, waiting...');
      // Try again after a short delay
      setTimeout(initializePaymentButtons, 500);
    }
  }
  
  /**
   * Ensure form has proper attributes for payment buttons
   */
  function ensureFormAttributes() {
    const productForm = document.querySelector('.native-product-form');
    
    if (!productForm) {
      console.log('💳 No product form found');
      return;
    }
    
    // Make sure the form has an ID for payment buttons to reference
    if (!productForm.id) {
      productForm.id = 'product-form-' + Date.now();
      console.log('💳 Added ID to product form:', productForm.id);
    }
    
    // Ensure form has the necessary data attributes
    if (!productForm.hasAttribute('data-product-form')) {
      productForm.setAttribute('data-product-form', '');
      console.log('💳 Added data-product-form attribute');
    }
    
    // Temporarily restore form action for Shopify payment buttons to initialize
    const originalAction = productForm.dataset.originalAction || '/cart/add';
    if (!productForm.getAttribute('action')) {
      console.log('💳 Temporarily restoring form action for payment buttons...');
      productForm.setAttribute('action', originalAction);
      productForm.setAttribute('method', 'post');
      
      // Remove it again after payment buttons initialize (after a delay)
      setTimeout(() => {
        productForm.removeAttribute('action');
        productForm.removeAttribute('method');
        console.log('💳 Form action removed again after payment button init');
      }, 3000);
    }
  }
  
  /**
   * Fix payment button wrapper positioning
   */
  function fixPaymentButtonWrapper() {
    const wrapper = document.querySelector('.shop-pay-button-wrapper');
    
    if (!wrapper) return;
    
    // Ensure wrapper is visible
    wrapper.style.display = 'block';
    wrapper.style.opacity = '1';
    
    // Remove any loading/skeleton elements that might be stuck
    const skeletons = wrapper.querySelectorAll('.shopify-payment-button__skeleton');
    skeletons.forEach(skeleton => {
      skeleton.style.display = 'none';
      console.log('💳 Removed payment button skeleton');
    });
  }
  
  /**
   * Monitor for dynamic content changes
   */
  function setupMutationObserver() {
    const wrapper = document.querySelector('.shop-pay-button-wrapper');
    
    if (!wrapper) {
      console.log('💳 Payment wrapper not found for observer');
      return;
    }
    
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          console.log('💳 Payment button content changed, reinitializing...');
          fixPaymentButtonWrapper();
        }
      });
    });
    
    observer.observe(wrapper, {
      childList: true,
      subtree: true
    });
    
    console.log('💳 Mutation observer set up for payment buttons');
  }
  
  /**
   * Force refresh payment buttons
   */
  function forceRefreshPaymentButtons() {
    console.log('💳 Force refreshing payment buttons...');
    
    const wrapper = document.querySelector('.shop-pay-button-wrapper');
    if (!wrapper) return;
    
    // Trigger a re-render by temporarily hiding and showing
    wrapper.style.display = 'none';
    requestAnimationFrame(() => {
      wrapper.style.display = 'block';
      
      // Try to initialize again
      if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
        try {
          Shopify.PaymentButton.init();
          console.log('✅ Payment buttons force refreshed');
        } catch (error) {
          console.warn('⚠️ Could not force refresh payment buttons:', error);
        }
      }
    });
  }
  
  /**
   * Main initialization function
   */
  function init() {
    console.log('💳 Starting payment button initialization sequence...');
    
    // Step 1: Ensure form has proper attributes
    ensureFormAttributes();
    
    // Step 2: Fix wrapper positioning
    fixPaymentButtonWrapper();
    
    // Step 3: Initialize payment buttons
    initializePaymentButtons();
    
    // Step 4: Set up mutation observer
    setupMutationObserver();
    
    // Step 5: Force refresh after a delay (fallback)
    setTimeout(forceRefreshPaymentButtons, 2000);
    
    console.log('✅ Payment button initialization sequence complete');
  }
  
  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Also try to initialize when variant changes
  document.addEventListener('variantChange', function() {
    console.log('💳 Variant changed, reinitializing payment buttons...');
    setTimeout(initializePaymentButtons, 300);
  });
  
  // Expose force refresh globally for debugging
  window.refreshPaymentButtons = forceRefreshPaymentButtons;
  
})();

